import React from 'react';

// Components
import Hero from '../Components/Hero';
import Carousel from '../Components/Carousel';
import AboutMeSection from '../Components/AboutMeSection';
import PreviousWork from '../Components/PreviousWork';
import GoToSection from '../Components/GoToSection';
import Education from '../Components/Education';
import FeaturedCarousel from '../Components/FeaturedCarousel';

function HomePage(props) {
    return (
        <div>
            <Hero title={props.title} location={'Kansas City, MO'} subTitle={props.subTitle} />

            <div style={{ paddingTop: '0px', paddingBottom: '50px', paddingLeft: '20px', paddingRight: '20px' }}>
                <FeaturedCarousel />
            </div>

            <PreviousWork />

            <AboutMeSection />

            <Education />

        </div>
    );
}

export default HomePage;